
export class DocumentFile {
  name = '';
  blob;
  size?;
  lastUpdate?;
  extension?;
}
